// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-wrapped[data-v-5062595a] {\n  overflow-x: auto;\n  width: 100%;\n}\n.table[data-v-5062595a] {\n  font-size: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
